import React from 'react';
import {Routes, BrowserRouter} from 'react-router-dom';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Импортируем стили Bootstrap
import './style/App.css';
import './style/index.css';
import TreeMenu from "./components/Menu/ui/TreeMenu";
import Shapka from './components/Shapka';
import MenuTransitions from "./components/Menu/ui/MenuTransitions";
import ScrollToTopButton from "./components/ScrollToTop";
import {menu} from "./components/Menu/const/menu";
import {buildMenuTree} from "./shared/buildMenuTree";
import PagesSharp from './pages/PagesSharp';
import "yet-another-react-lightbox/styles.css";

const App: React.FC = () => {
// Преобразуем меню
    const menuData = buildMenuTree(menu());

    // Получаем текущую дату
    const currentDate = new Date();

    // Извлекаем текущий год
    const currentYear = currentDate.getFullYear();

    return (
        <>
            <BrowserRouter>
                <Shapka/>

                <div className="container-fluid">

                        <MenuTransitions/>
                        <div className="row">
                            <div className="col-md-3 sidebar-menu d-none d-md-block">
                                <div>
                                    <TreeMenu data={menuData}/>
                                </div>
                            </div>
                            <div className="col-md-9 main">
                                <PagesSharp/>
                            </div>
                        </div>

                </div>
            </BrowserRouter>
            <footer className="container footer">
                <div className="row">
                    <div className="col-sm-2 col-md-2"><p className="copyright">© {currentYear}</p></div>
                    <div className="col-sm-7 col-md-9"><p className="copyright">Перепечатка материалов сайта только при
                        наличии активной ссылки <a href="/">{window.location.host}</a></p></div>
                    <div className="col-sm-3 col-md-1 px-0 text-center"><a className="icon-tg"
                                                                           href="https://t.me/dpi_style"><img
                        src="/image/icons/telegram.png" alt=""/></a></div>
                </div>
            </footer>

            <a href="#top" id="scrollup" className="hidden-xs">Наверх</a>
            <ScrollToTopButton/>
        </>
    );
}

export default App;
